import React, { useContext, useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table';
import { Col, Container, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { GlobalContext } from '../../context/provider';
import { LoginContext } from '../../../home/logincontext';
import { AiOutlineCheckCircle } from "react-icons/ai";
import { MdEditNote } from "react-icons/md";
import numberbeautifuly from '../../../utils/numberbeautify';

const Income_report_list = () => {
    const { reportState, reportDispatch } = useContext(GlobalContext);
    return (
        <div dir='rtl'>
            <Container>
                <Row className='justify-content-md-center mt-5'>
                    <Col lg={11}>
                        <Table striped bordered hover size="lg" style={{ textAlign: 'center' }} >
                            <thead>
                                <tr>
                                    <th>ناوی کۆمپانیا</th>
                                    <th>بڕی پارە</th>
                                    <th>بەروار</th>
                                    <th>ژمارەی پسوڵە</th>
                                    <th>تێبینی</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: 12 }}>
                                {reportState.income_report.map((lis) => (
                                    <tr style={{ cursor: 'pointer' }}>
                                        <td>{lis.radio_income_name}</td>
                                        <td>{numberbeautifuly(lis.radio_income_amount)} IQD</td>
                                        <td>{lis.radio_income_date}</td>
                                        <td>{lis.radio_income_invoice}</td>
                                        <td>{lis.radio_income_note}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Income_report_list